module.exports = __webpack_public_path__ + "img/semi_driving.b6a60143.svg";